import firebase from 'firebase/compat/app'
import { getFirestore } from '@firebase/firestore'
import { getStorage } from '@firebase/storage'
import 'firebase/compat/auth'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

const app = firebase.initializeApp(firebaseConfig)

// Banco principal (default) — usado por todo o admin e pelo app
export const db = getFirestore(app)

// Banco Enterprise do AI Studio — sincronizado automaticamente via categories.js
// Qualquer create/update/delete em categories reflete aqui em tempo real
export const dbAiStudio = getFirestore(
  app,
  process.env.REACT_APP_FIREBASE_AI_STUDIO_DB_ID ||
  'ai-studio-connectourmobile-144d078f-3c39-4f85-9d24-998da1e7c439'
)

export const storage = getStorage(app)
export const auth = app.auth()
export default app
